// extracted by mini-css-extract-plugin
export default {"workorder_page":"workorder_workorder_page__gvDvb","workorder_page_content":"workorder_workorder_page_content__ORD+H","left_center_right":"workorder_left_center_right__MolEd"};